import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import animated from 'animate.css/animate.compat.css'//引入动画
import './assets/css/style.scss' /*引入公共样式*/
createApp(App).use(store).use(animated).use(router).mount('#app')
